import React from "react";
function createUseAuth(AuthContext) {
  const useAuth = () => {
    const context = React.useContext(AuthContext);
    if (!context) {
      throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
  };
  return useAuth;
}
function useNoAuth() {
  return {
    loading: false,
    isAuthenticated: false,
    logIn: async () => {
    },
    logOut: async () => {
    },
    signUp: async () => {
    },
    currentUser: null,
    userMetadata: null,
    getToken: async () => null,
    getCurrentUser: async () => null,
    hasRole: () => false,
    reauthenticate: async () => {
    },
    forgotPassword: async () => {
    },
    resetPassword: async () => {
    },
    validateResetToken: async () => {
    },
    type: "default",
    client: void 0,
    hasError: false
  };
}
export {
  createUseAuth,
  useNoAuth
};
